// Näitä ei ilmeisesti enää käytetä niin kommentoitu
//import deleteObjectOnPick from "./helpers/deleteObjectOnPick.js";
//import addMetadataToMesh from "./helpers/addMetadataToMesh.js";

//import "pepjs";
//import * as dat from "dat.gui";
//import * as LTFValidator from "gltf-validator";
//import * as earcut from "earcut";
//import "babylonjs";
//import "babylonjs-materials";
//import "babylonjs-inspector";
//import "babylonjs-procedural-textures";
//import "babylonjs-post-process";npm
//import "babylonjs-loaders";
//import "babylonjs-serializers";
import "./index.css";
import buildTwitter from "./puzzles/twitter/index.js";
import buildFacebookFlat from "./puzzles/facebook/flat.js";
import buildFacebookWarehouse from "./puzzles/facebook/warehouse.js";
import buildFacebookBunker from "./puzzles/facebook/bunker.js";
import emailPuzzle from "./puzzles/email/index.js";
import magazineOnTable from "./tips/2DImageView/index.js";
import cameraPuzzle from "./puzzles/camera/index.js";
import cameraLockerPuzzle from "./puzzles/cameraLocker";
import posterPuzzle from "./puzzles/poster/index.js";
import clockPuzzle from "./puzzles/clock";
import framegramPuzzle from "./puzzles/frameGram";
import buildControlPanel from "./puzzles/electricControlPanel";
import buildLockConsole from "./puzzles/lockconsole";
import buildWallSwitch from "./puzzles/wallSwitch";
import buildExtra from "./puzzles/extra.js";
import pointerLockEvents from "./helpers/pointerLockEvents";
import { displayLoadingUI, hideLoadingUI } from "./helpers/loadingScreen.js";
import { assetsManager, assetContainers } from "./helpers/assetsManager";
//  import * as GUI from "babylonjs-gui";
import { checkTipGlow } from "./helpers/checkGlow";
import {
  flatDoors as loadFlatDoors,
  warehouseDoors as loadWarehouseDoors,
} from "./animatedObjects/doors.js";
import { userChoiceTracker } from "./helpers/userChoiceTracker";
import { tips, TipWindow, clearAllTips } from "~src/tips/index.js";
import { controlPointer } from "./helpers/controlPointer";
import { tip2DImageLauncher } from "./tips/2DImageView/index.js";
import { shortcuts, shortcutDetected } from "./helpers/shortcuts";
//siirretty tähän ulkopuolelle jotta muutkin moduulit voi käyttää
import { createSounds } from "./sounds.js";
import { optimizer } from "./helpers/optimizer";
import { VirtualJoystick } from "./helpers/virtualJoystick.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { InfoScreen } from "./infoScreen";
// fullscreens
import {
  StartingScreen,
  everythingReady,
} from "./fullscreenModals/startingScreen.js";
import EndingScreen from "./fullscreenModals/endingScreen.js";
import OrientationAlert from "./fullscreenModals/orientationAlert";
import { computerScreens } from "./helpers/computerScreens.js";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import { deleteYleElements } from "./helpers/deleteYleElements";
import { countUpTimer } from "./helpers/countUpTimer";
import { registerEvent } from "./helpers/analyticsMethods";
import { resizeJobs } from "./helpers/windowResize";
import { disableiOSRubberScroll } from "./helpers/iOSHacks";
import { textContents } from "./textcontents.js";
export const frameRate = 30;



let gameSounds;

export const getGameSounds = () => gameSounds;

export let puzzleLaunchers = {
  twitter: (logged) => {
    tips.gameStarted.clear();
    registerEvent("twitter_avattu")
    buildTwitter(logged || false, () => {
      if (
        userChoiceTracker.retrieve().posterPuzzle &&
        !userChoiceTracker.retrieve().rightTwitterPassword
      ) {
        tips.twitterPassword.setTime(10);
      }

      if (
        userChoiceTracker.retrieve().rightTwitterPassword &&
        !userChoiceTracker.retrieve().corridorDoorOpened
      ) {
      }

      if (
        userChoiceTracker.retrieve().rightTwitterPassword &&
        userChoiceTracker.retrieve().corridorDoorOpened
      ) {
        tips.lockConsole.setTime(35);
      }
    });
  },
  matrixPoster: () => {
    // MATRIX-JULISTE
    tips.matrixPoster.clear();
    tips.gameStarted.clear();
    registerEvent("Matrix_avattu")
    posterPuzzle(
      () => {
        // CLOSE BUTTON CALLBACK
        // if poster is completed, hide "kesken" mesh and show "valmis" mesh
        if (userChoiceTracker.retrieve().posterPuzzle) {
          // true if completed correctly
          registerEvent("Matrix_ratkaistu")
          scene.getMeshByName("H1_Matrixjuliste_Valmis").setEnabled(true);
          scene.getMeshByName("H1_Matrixjuliste_Kesken").setEnabled(false);
          tips.solveMatrix.clear();
          tips.goToTwitter.setTime(30);
        }
        if (!userChoiceTracker.retrieve().posterPuzzle) {
          // false if not completed correctlyi
          
          if (!tips.solveMatrix.retrieveData()) {
            // this makes sure it's only called once
            tips.solveMatrix.setTime(10);
          }
        }
      },
      {
        paperMovement: gameSounds?.paperMovement,
        paperRightPlace: gameSounds?.paperRightPlace,
      }
    );
  },
  flatDoorKnob: () => {
    if (
      doorTriggers.openFlatCorridor &&
      userChoiceTracker.openedDoors.indexOf("flatCorridor") < 0
    ) {
      tips.twitterExplained.clear();
      doorTriggers.openFlatCorridor();
      if (userChoiceTracker.retrieve().rightTwitterPassword) {
        tips.lockConsole.setTime(35);
      }
      userChoiceTracker.addOpenedDoor("flatCorridor");
      gameSounds?.fcDoorSound?.play();        
      const knob = scene.getMeshByName("fDoorKnob")
      knob?.dispose?.(true, true);
    }
  },
  meloniConsole: () => {
    tips.lockConsole.clear();

    /*     const cameraHelpers = {
      attachControl: () => camera.attachControl(canvas, true),
      detachControl: () =>
        camera.detachControl(document.querySelector("canvas")),
    };
 */
    registerEvent("Meloni_avattu")
 tips.solveLockConsole.setTime(30);

    buildLockConsole(() => {
      registerEvent("Meloni_ratkaistu")
      tips.solveLockConsole.clear();
      tips.matrixPoster.clear();
      //cameraHelpers.detachControl();
      assetContainers.warehouse.addToScene();
      loadWarehouseDoors(scene, frameRate)
        .then((e) => {
        
          clearAllTips();
          const lukkokonsoliOpen = scene.getMeshByName("H1_lukkokonsoli_Auki");
          if (lukkokonsoliOpen) lukkokonsoliOpen.setEnabled(true);

          const lukkokonsoliClosed = scene.getMeshByName(
            "H1_lukkokonsoli_Kiinni"
          );
          if (lukkokonsoliClosed) lukkokonsoliClosed.setEnabled(false);
          doorTriggers = { ...doorTriggers, ...e };
          doorTriggers.openWarehouse();
          window.scene.getSoundByName("soundWhDoor").play();
          tips.magazine.setTime(90);

          //          cameraHelpers.attachControl();
          checkTipGlow(scene);
          if (gameSounds?.musicFlat?.isPlaying) {
            gameSounds?.musicFlat?.stop();
          }
          gameSounds?.musicWarehouse?.play();
          userChoiceTracker.addOpenedDoor("warehouse");
        })
        .catch((error) => {
          console.log(error);
         // cameraHelpers.attachControl();
        });
    });
  },
  lockConsole: () => {
    registerEvent("Kamerakaappi_avattu")
    if (userChoiceTracker.openedDoors.indexOf("cameraLocker") < 0) {
      tips.solveCameraLocker.setTime(30);
      tips.cameraLocker.clear();
      cameraLockerPuzzle(() => {
        tips.solveCameraLocker.clear();
        tips.camera.setTime(30);
        doorTriggers.openLocker();
        tips.magazine.clear();
        userChoiceTracker.addOpenedDoor("cameraLocker");
      });
    } else {
      cameraPuzzle(() => {
        tips.camera.clear();
      });
    }
  },
  facebookPuzzle: () => {
    tips.bunkerComputer.clear();
    buildFacebookBunker();
  },
  electricPanel: () => {
  registerEvent("Sahkokaappi_avattu")
    tips.bunkerFound.clear();
    tips.controlPanel.clear(0);
    tips.solveControlPanel1.setTime(60);
    buildControlPanel(scene, gameSounds.electricPanelSoundSet || null);
  },
  frameGram: () => {
    tips.warehouseComputer.clear();
    framegramPuzzle();
  },
  email: () => {
    tips.flatComputer.clear();
    emailPuzzle();
  },
  clock: () => {
    // check if it's finished already

    if (userChoiceTracker.retrieve().clockPuzzle) return false;

    tips.solveClock1.setTime(50);
    const callback = async () => {
      assetContainers.bunker.addToScene(scene);
      clearAllTips();
      registerEvent("Kello_ratkaistu")

      userChoiceTracker.addOpenedDoor("bunker");
      doorTriggers.openBunker();
      tips.bunkerFound.setTime(10);
      checkTipGlow(scene);
      tips.controlPanel.setTime(120);
     scene.getMeshByName("whPuzzle4")?.dispose(); 
      gameSounds?.bunkerDoorSound?.play();
      if (gameSounds?.musicFlat?.isPlaying) {
        gameSounds?.musicFlat?.stop();
      }
      if (gameSounds?.musicWarehouse?.isPlaying) {
        gameSounds?.musicWarehouse?.stop();
      }
      gameSounds?.musicBunker?.play();
    };
    clockPuzzle(callback);
  },
  flatPosterSafari: () => {
        if(!countUpTimer.isInitialized()) countUpTimer.init()
    buildWallSwitch(() => {

      registerEvent("Kahva_vaannetty")
      doorTriggers.openExit();
      camera.onCollide = (collidedMesh) => {
        
        if (
          collidedMesh.id === "Huone1_exitcube" &&
          userChoiceTracker.openedDoors.indexOf("exit") < 0
        ) {
          userChoiceTracker.addOpenedDoor("exit");

          camera.detachControl(document.querySelector("canvas"));
          registerEvent("Ovi_ulos")
          EndingScreen();
        }
      };
    }, gameSounds.exitDoorsSoundSet || null);
  },
};

export let doorTriggers = {
  //  When door meshes are loaded (either in babylonScene.js helpers/shortcuts.js), this object has following function properties which each opens one door:
  // usage: doorTriggers.openFlatCorridor();
  // openFlatCorridor,
  // openWarehouse,
  // openExit
  // openBunker
};

/* let currentRoom = "flat";

let previousRoom = null;

const storeCurrentRoom = (newRoom) => {
  if (currentRoom) {
    previousRoom = currentRoom;
  }
  currentRoom = newRoom;
}; */
const createCustomCameraHelpers = () => {
  let helpers = {};

  let storeHelpers = (newHelpers) => (helpers = { ...helpers, ...newHelpers });

  return {
    getHelpers: () => helpers,
    init: (helpers) => storeHelpers(helpers),
  };
}

export const customCameraHelpers = createCustomCameraHelpers();

// This is needed to disable zooming on mobile devices
var meta = document.createElement("meta");
meta.setAttribute("name", "viewport");
meta.setAttribute(
  "content",
  "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0j"
);

export const saveDoorTriggers = (data) => {
  doorTriggers = { ...doorTriggers, ...data };
};
// Scene *********************************************************************************************************
var createScene = function (engine, canvas) {

  window.addEventListener("resize", function () {
    resizeJobs(engine)
  })

  BABYLON.Engine.audioEngine.useCustomUnlockedButton = true;
  var scene = new BABYLON.Scene(engine);
  scene.clearColor = new BABYLON.Color3(0,0,0);
  scene.gravity = new BABYLON.Vector3(0, -0.9, 0);
  scene.collisionsEnabled = true;
  var camera = new BABYLON.UniversalCamera(
    "UniversalCamera",
    new BABYLON.Vector3(5, 14, -10),
    scene
  );
  camera.fov = 0.9;
  camera.angularSensibility = 3500;
  camera.speed = 0.75;
  camera.checkCollisions = true;
  camera.applyGravity = true;
  camera.rotation.y = 1.6;
  camera.ellipsoid = new BABYLON.Vector3(2, 7, 2);
  camera.keysUp.push(87);
  camera.keysDown.push(83);
  camera.keysRight.push(68);
  camera.keysLeft.push(65);
  camera.attachControl(canvas, true);

  scene.onPointerDown = function (evt) {
    pointerLockEvents.lockPointerToCanvas();
    castRay({ runCallbacks: true });
    document.querySelector("#click-with-mouse")?.remove();
    document.querySelector("#kohdistin1").style.display = "block";
    const footSteps = scene.getSoundByName("footSteps")
    document.addEventListener("keydown", function (evt) {
      switch (evt.keyCode) {
        case 37:
        case 38:
        case 39:
        case 40:
        case 65:
        case 68:
        case 83:
        case 87:
          if (!footSteps.isPlaying) {
            footSteps.play();
          }
          break;
      }
    });
    document.addEventListener("keyup", function (evt) {
      switch (evt.keyCode) {
        case 37:
        case 38:
        case 39:
        case 40:
        case 65:
        case 68:
        case 83:
        case 87:
          if (footSteps?.isPlaying) {
            footSteps.stop();
          }
          break;
      }
    });
  };

  var light = new BABYLON.HemisphericLight(
    "light1",
    new BABYLON.Vector3(0, -1, 0),
    scene
  );
  light.diffuse = new BABYLON.Color3(0.95, 0.82, 0.73, 0.78);
  light.specular = new BABYLON.Color3(0, 0, 0);
  light.groundColor = new BABYLON.Color3(0.93, 0.8, 1, 0.57);
  light.intensity = 0.25;

  // Blocker for dirty mechanism
  scene.blockMaterialDirtyMechanism = true;
  // lisä-juttuja optimointiin
  BABYLON.OBJFileLoader.OPTIMIZE_WITH_UV = true;
  BABYLON.OBJFileLoader.MATERIAL_LOADING_FAILS_SILENTLY = false;
  //#endregion'c

  const loadAtStart = (async () => {

    document.addEventListener("keydown", function (evt) {
      if (evt.keyCode === 73) InfoScreen();
      if(event.key === "Escape"){
        
        window.currentModalExit?.()
      }
    });   


    camera.onCollide = () => {
      countUpTimer.init(); 
      

      camera.onCollide = null;
    }

    assetsManager.init(BABYLON, scene);

    await assetsManager.loadImages();
    assetsManager.loadLevelCollision(scene);
    assetsManager.loadBunker(scene);
    assetsManager.loadWarehouse(scene);
    assetsManager.loadFlat(scene);

    let someFlatObjs = [
      "Huone1_seinat",
      "Huone1_exitcube",
      "H1_Telkkari_Ruutu",
      "H1_lukkokonsoli_Auki",
      "H1_lukkokonsoli_Kiinni",
      "H1_TwitterNaytto",
      "planeTv",
      "_H1_R_kirjat_uni",
      "_H1_R_kirjat_tuoli",
      "_H1_R_kirjat_poyta",
      "_H1_R_energiajuoma",
      "_H1_R_jalkapallo",
      "_H1_R_Lapio",
      "Huone1_Puhelin.001",
      "H1__Yhdistetyt",
    ];

    let someBunkerObjs = [
      "H3__Yhdistetyt",
      "H3_puhelin",
      "H3_Betoniporsaat_Mesh",
    ];

    scene.onReadyObservable.add(() => {
      disableiOSRubberScroll();
      optimizer(scene, engine);
      everythingReady();
      checkTipGlow(scene);
      engine.resize();
      document.body.classList.remove("hideImages") 
      if (mobileOrNot()) {
        VirtualJoystick(scene, camera, canvas);
      }


    scene.clearColor = new BABYLON.Color3(255, 255, 255);

      controlPointer(scene, camera, castRay);

deleteYleElements();
     


        /*
        
        
      camera.onCollide = (collidedMesh) => {
        if (userChoiceTracker.openedDoors.indexOf("bunker") < 0) return;
        // When bunker entered, let's start this
        if (collidedMesh.id.toUpperCase().indexOf("HUONE1") > -1) {
          if (currentRoom !== "flat") {
            storeCurrentRoom("flat");

            for (let i = 0; i < someFlatObjs.length; i++) {
              const ob = scene.getMeshByName(someFlatObjs[i]);
              if (ob) ob.setEnabled(true);
            }

            for (let i = 0; i < someBunkerObjs.length; i++) {
              const ob = scene.getMeshByName(someBunkerObjs[i]);
              if (ob) ob.setEnabled(false);
            }
          }
        }
        if (collidedMesh.id.toUpperCase().indexOf("HUONE2") > -1) {
          if (currentRoom !== "warehouse") {
            storeCurrentRoom("warehouse");
            if (previousRoom === "flat") {
              for (let i = 0; i < someFlatObjs.length; i++) {
                const ob = scene.getMeshByName(someFlatObjs[i]);
                if (ob) ob.setEnabled(false);
              }

              for (let i = 0; i < someBunkerObjs.length; i++) {
                const ob = scene.getMeshByName(someBunkerObjs[i]);
                if (ob) ob.setEnabled(true);
              }
            }

            if (previousRoom === "bunker") {
              for (let i = 0; i < someFlatObjs.length; i++) {
                const ob = scene.getMeshByName(someFlatObjs[i]);
                if (ob) ob.setEnabled(true);
              }

              for (let i = 0; i < someBunkerObjs.length; i++) {
                const ob = scene.getMeshByName(someBunkerObjs[i]);
                if (ob) ob.setEnabled(false);
              }
            }
          }
        } */

        /*         if (collidedMesh.id.toUpperCase().indexOf("HUONE3") > -1) {
          if (currentRoom !== "bunker") {
            storeCurrentRoom("bunker");

            for (let i = 0; i < someBunkerObjs.length; i++) {
              const ob = scene.getMeshByName(someBunkerObjs[i]);
              if (ob) ob.setEnabled(true);
            }

            for (let i = 0; i < someFlatObjs.length; i++) {
              const ob = scene.getMeshByName(someFlatObjs[i]);
              if (ob) ob.setEnabled(false);
            }
          }
        } 
      };
        */
      assetContainers.flat.addToScene(scene);

      loadFlatDoors(scene, frameRate).then((e) => {
        doorTriggers = { ...doorTriggers, ...e };
      });
      shortcuts(scene, customCameraHelpers);
      addVideo();
    });
  })();

  //#endregion

  var crosshair = BABYLON.Mesh.CreateDisc("crosshair", 0.01, 12, scene);
  // crosshair tulee kaiken muun päälle
  //crosshair.renderingGroupId = 1;
  // billboardin avulla käännettynä aina ruutuun päin
  crosshair.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
  crosshair.visibility = 0;

  // crosshair saa kameran position
  crosshair.position = camera.getTarget();

  // These hold information on how many times doors have been clicked – used to display tips
  let whDoorClicked = 0;
  let buDoorClicked = 0;

  // RAYcasting
  function castRay({ runCallbacks }) {
    const warehouseDoor = scene.getMeshByName("H1_Varaston_ovi");
    const bunkerDoor = scene.getMeshByName("H2_Bunkkerin_ovi");
    const exitDoor = scene.getMeshByName("H1_Ulko_ovi");
    //kameran(pelaajan näkövinkkelistä tuleva ray) 10-20 on hyvä matka noin käden mitta
    var ray = camera.getForwardRay(20);
    /* // tämä laittaa rayn näkymään
let rayHelper = new BABYLON.RayHelper(ray); 
rayHelper.show(scene);  */
    const meshesWithActivators = [
      // this LIST consists of objects containing two things:
      // 1: MESH - catches if clicked AND in collision with ray
      // 2. CALLBACK
      {
        mesh: warehouseDoor,
        callback: () => {
          if (whDoorClicked > 2) {
          }
          whDoorClicked++;
        },
      },
      {
        mesh: bunkerDoor,
        callback: () => {
          buDoorClicked++;
        },
      },
      {
        mesh: exitDoor,
        callback: () => {
          if (!gameSounds?.exitDoorNotOpen?.isPlaying) {
            gameSounds?.exitDoorNotOpen?.play?.();
          }
        },
      },
      {
        mesh: flatPuzzle1,
        callback: () => puzzleLaunchers.twitter(false),
      },
      {
        mesh: flatPuzzle2,
        callback: puzzleLaunchers.email,
      },
      {
        mesh: flatPuzzle3,
        callback: puzzleLaunchers.matrixPoster,
      },
      {
        mesh: warehousePuzzle1,
        callback: puzzleLaunchers.frameGram,
      },
      {
        mesh: warehousePuzzle2,
        callback: () => {
          registerEvent("Lehti_avattu")
          tip2DImageLauncher.magazine();
          tips.magazine.clear();
        },
      },
      //   {mesh: warehousePuzzle3, callback: buildPuzzle7},
      {
        mesh: warehousePuzzle4,
        callback: puzzleLaunchers.clock,
      },
      {
        mesh: bunkerPuzzle1,
        callback: puzzleLaunchers.electricPanel,
      },
      {
        mesh: bunkerPuzzle2,
        callback: puzzleLaunchers.facebookPuzzle,
      },
      {
        mesh: flatLockConsole,
        callback: puzzleLaunchers.meloniConsole,
      },

      {
        mesh: flatDoorKnob,
        callback: puzzleLaunchers.flatDoorKnob,
      },
      {
        mesh: flatPosterSafari,
        callback: puzzleLaunchers.flatPosterSafari,
      },
      {
        mesh: flatExtra9,
        callback: () => {
          tip2DImageLauncher.energydrink();
        },
      },
      {
        mesh: flatExtra10,
        callback: () => {
          tip2DImageLauncher.football();
        },
      },
      {
        mesh: flatExtra11,
        callback: () => {
          tip2DImageLauncher.shovel();
        },
      },
      // PUHELIMET 3KPL

      {
        mesh: flatExtra12,
        callback: () => TipWindow(scene),
      },
      {
        mesh: warehouseExtra16,
        callback: () => TipWindow(scene),
      },
      {
        mesh: bunkerTelephone,
        callback: () => {
          TipWindow(scene);
        },
      },
      {
        mesh: warehouseExtra1,
        callback: () => {
          tip2DImageLauncher.wrench();
        },
      },
      {
        mesh: warehouseExtra5,
        callback: () => {
          tip2DImageLauncher.fuelCan();
        },
      },

      {
        mesh: scene.getMeshByName("sahkolaatikko_collision"),
        callback: puzzleLaunchers.lockConsole,
      },
      {
        mesh: bunkerExtra3,
        callback: () => {
          tip2DImageLauncher.book();
        },
      },
      {
        mesh: bunkerSprayCan,
        callback: () => {
          tip2DImageLauncher.sprayCan();
        },
      },
    ];

    // 1/3 check if there is a collision with any of the meshes specified above
    const checkCollisions = scene.pickWithRay(ray, (mesh) => {
      return meshesWithActivators.map((e) => e.mesh).indexOf(mesh) > -1;
    });

    if (checkCollisions.pickedMesh) {
      // 2/3 ok there is a collision, check for special cases:
      if (
        checkCollisions.pickedMesh.name === "flatComputer2" &&
        !computerScreens.flat.availableToUse()
      )
        return false;
      if (
        checkCollisions.pickedMesh.name === "warehouseComputer" &&
        !computerScreens.warehouse.availableToUse()
      )
        return false;
      if (
        checkCollisions.pickedMesh.name === "bunkerComputer" &&
        !computerScreens.bunker.availableToUse()
      )
        return false;
      // let's check which callback to run
      const arr = meshesWithActivators.filter(
        (e) => e.mesh === checkCollisions.pickedMesh
      );

      if (runCallbacks) if (arr.length > 0) arr[0].callback();

      return arr.length > 0;
    }
  }
  //#endregion

  //#region Muita modeleita ja partikeleita

  //#region

  const addVideo = () => {
    //#region Tv-ruutu
    var tvScreenVideo = BABYLON.MeshBuilder.CreatePlane(
      "planeTv",
      { width: 12.5, height: 6.3 },
      scene
    );
    tvScreenVideo.position = new BABYLON.Vector3(39, 9.5, -5.2);
    tvScreenVideo.rotation.y = -0.35;
    var tvScreenVideoMat = new BABYLON.StandardMaterial("m", scene);
    var tvScreenVideoVidTex = new BABYLON.VideoTexture(
      "tvSuhina",
      window.pakopeliPublicAssetUrl + "assets/Telkkari_suhina2.mp4",
      scene
    );
    tvScreenVideoMat.diffuseTexture = tvScreenVideoVidTex;
    tvScreenVideoMat.roughness = 1;
    tvScreenVideoMat.emissiveColor = new BABYLON.Color3.White();
    tvScreenVideo.material = tvScreenVideoMat;
    //#endregion

    const videoEl = tvScreenVideoVidTex.video
    videoEl.currentTime = 1
    videoEl.muted = true;
    videoEl.play()
  };

  //#region  Collision imposters
  // Flat/Huoneisto collision objektien ympärille
  var flatBox1 = BABYLON.MeshBuilder.CreateBox(
    "f_box1",
    { height: 2, width: 20, depth: 8, updatable: false, text: true },
    scene
  );
  flatBox1.position = new BABYLON.Vector3(24.3, 8, -44);
  flatBox1.visibility = 0;
  flatBox1.checkCollisions = true;
  flatBox1.freezeWorldMatrix = true;

  var flatBox2 = flatBox1.clone("f_box2");
  flatBox2.position = new BABYLON.Vector3(78, 7, -41);
  flatBox2.scaling.x = 0.9;
  flatBox2.rotation.y = 1.5;

  var flatBox3 = flatBox1.clone("f_box3");
  flatBox3.position = new BABYLON.Vector3(38.5, 7, -1);
  flatBox3.scaling.x = 0.7;

  var flatBox4 = flatBox1.clone("f_box4");
  flatBox4.position = new BABYLON.Vector3(49.3, 7, -20);
  flatBox4.scaling.x = 0.4;
  flatBox4.scaling.z = 1.2;
  flatBox4.rotation.y = 0.93;

  var flatBox5 = flatBox1.clone("f_box5");
  flatBox5.position = new BABYLON.Vector3(67, 7, -1.5);
  flatBox5.scaling.x = 0.2;

  var flatBox6 = flatBox1.clone("f_box6");
  flatBox6.position = new BABYLON.Vector3(3.1, 7, -50);
  flatBox6.rotation.y = 1.55;

  var flatBox7 = flatBox1.clone("f_box7");
  flatBox7.position = new BABYLON.Vector3(39.6, 7, -44.6);
  flatBox7.scaling.z = 0.3;
  flatBox7.scaling.x = 0.1;
  flatBox7.scaling.y = 2;

  var flatBox8 = flatBox1.clone("f_box8");
  flatBox8.position = new BABYLON.Vector3(30, 7, -38.33);
  flatBox8.scaling.z = 0.5;
  flatBox8.scaling.x = 0.2;
  flatBox8.scaling.y = 2.5;

  var flatExit = flatBox1.clone("f_exit");
  flatExit.position = new BABYLON.Vector3(-15, -1, -10);
  flatExit.scaling.z = 2.5;
  flatExit.scaling.x = 2.5;
  flatExit.scaling.y = 0.1;

  // Warehouse/varasto collision objektien ympärille
  var warehouseBox1 = BABYLON.MeshBuilder.CreateBox(
    "w_box1",
    { height: 10, width: 18, depth: 7, updatable: false, text: true },
    scene
  );
  warehouseBox1.position = new BABYLON.Vector3(66, 2.5, -223);
  warehouseBox1.visibility = 0;
  warehouseBox1.checkCollisions = true;
  warehouseBox1.freezeWorldMatrix = true;

  var warehouseBox2 = warehouseBox1.clone("w_box2");
  warehouseBox2.position = new BABYLON.Vector3(37, -3, -221);
  warehouseBox2.scaling.x = 1.2;
  warehouseBox2.scaling.z = 0.9;
  warehouseBox2.rotation.y = 0.5;

  var warehouseBox3 = warehouseBox1.clone("w_box3");
  warehouseBox3.position = new BABYLON.Vector3(32, 0, -146.5);
  warehouseBox3.scaling.z = 5.9;
  warehouseBox3.scaling.x = 0.4;

  var warehouseBox4 = warehouseBox1.clone("w_box4");
  warehouseBox4.position = new BABYLON.Vector3(36, 2.5, -103);
  warehouseBox4.scaling.x = 0.8;
  warehouseBox4.scaling.z = 1.5;

  var warehouseBox5 = warehouseBox1.clone("w_box5");
  warehouseBox5.position = new BABYLON.Vector3(75, -5, -136.5);
  warehouseBox5.scaling.x = 0.5;
  warehouseBox5.scaling.z = 2.5;

  var warehouseBox6 = warehouseBox1.clone("w_box6");
  warehouseBox6.position = new BABYLON.Vector3(37, -5, -166);
  warehouseBox6.scaling.x = 0.15;
  warehouseBox6.scaling.z = 1.7;

  var warehouseBox7 = warehouseBox1.clone("w_box7");
  warehouseBox7.position = new BABYLON.Vector3(34, -5, -180);
  warehouseBox7.scaling.x = 0.1;
  warehouseBox7.scaling.z = 2.1;
  warehouseBox7.rotation.y = -0.4;

  var warehouseBox8 = warehouseBox1.clone("w_box8");
  warehouseBox8.position = new BABYLON.Vector3(76, -5, -205);
  warehouseBox8.scaling.x = 0.1;
  warehouseBox8.scaling.z = 2;
  warehouseBox8.rotation.y = 0.45;

  var warehouseBox9 = warehouseBox1.clone("w_box9");
  warehouseBox9.position = new BABYLON.Vector3(73, -5, -101);
  warehouseBox9.scaling.x = 0.1;
  warehouseBox9.scaling.z = 1;

  var warehouseBox10 = warehouseBox1.clone("w_box10");
  warehouseBox10.position = new BABYLON.Vector3(125, -8.5, -196);
  warehouseBox10.scaling.x = 0.1;
  warehouseBox10.scaling.z = 2.7;
  warehouseBox10.scaling.y = 0.1;

  // Bunker/bunkkeri collision objektien ympärille
  var bunkerBox1 = BABYLON.MeshBuilder.CreateBox(
    "b_box1",
    { height: 2, width: 26, depth: 10, updatable: false, text: true },
    scene
  );
  bunkerBox1.position = new BABYLON.Vector3(192, -26, -144);
  bunkerBox1.visibility = 0;
  bunkerBox1.checkCollisions = true;
  bunkerBox1.rotation.y = 1.15;

  var bunkerBox2 = bunkerBox1.clone("b_box2");
  bunkerBox2.position = new BABYLON.Vector3(185, -25, -151);
  bunkerBox2.scaling.x = 0.43;
  bunkerBox2.scaling.z = 1.8;
  bunkerBox2.scaling.y = 2;
  bunkerBox2.rotation.y = 0.75;

  var bunkerBox3 = bunkerBox1.clone("b_box3");
  bunkerBox3.position = new BABYLON.Vector3(138, -33, -130);
  bunkerBox3.scaling.x = 0.5;
  bunkerBox3.scaling.z = 1.8;
  bunkerBox3.scaling.y = 0.9;
  bunkerBox3.rotation.y = 0.45;

  var bunkerBox4 = bunkerBox1.clone("b_box4");
  bunkerBox4.position = new BABYLON.Vector3(136, -31.8, -134);
  bunkerBox4.scaling.x = 0.48;
  bunkerBox4.scaling.z = 1.6;
  bunkerBox4.scaling.y = 2;
  bunkerBox4.rotation.y = 0.45;

  var bunkerBox5 = bunkerBox1.clone("b_box5");
  bunkerBox5.position = new BABYLON.Vector3(135, -30, -135);
  bunkerBox5.scaling.x = 0.5;
  bunkerBox5.scaling.z = 1.2;
  bunkerBox5.scaling.y = 2.2;
  bunkerBox5.rotation.y = 0.45;

  var bunkerBox6 = bunkerBox1.clone("b_box6");
  bunkerBox6.position = new BABYLON.Vector3(133, -30, -146);
  bunkerBox6.scaling.x = 0.2;
  bunkerBox6.scaling.z = 1;
  bunkerBox6.scaling.y = 3.5;
  bunkerBox6.rotation.y = 0.75;

  var bunkerBox7 = bunkerBox1.clone("b_box7");
  bunkerBox7.position = new BABYLON.Vector3(133, -5, -205);
  bunkerBox7.scaling.x = 0.6;
  bunkerBox7.scaling.z = 0.5;
  bunkerBox7.scaling.y = 3.5;
  bunkerBox7.rotation.y = 0;

  var bunkerBox8 = bunkerBox1.clone("b_box8");
  bunkerBox8.position = new BABYLON.Vector3(160, -30, -197);
  bunkerBox8.scaling.x = 1;
  bunkerBox8.scaling.z = 2;
  bunkerBox8.scaling.y = 5;
  bunkerBox8.rotation.y = 0;

  var bunkerBox9 = bunkerBox1.clone("b_box9");
  bunkerBox9.position = new BABYLON.Vector3(132.8, -30, -183);
  bunkerBox9.scaling.x = 0.6;
  bunkerBox9.scaling.z = 0.8;
  bunkerBox9.scaling.y = 3;
  bunkerBox9.rotation.y = 1.4;

  //pöly ikkunasta - flat
  var dustPlane = BABYLON.MeshBuilder.CreatePlane(
    "taso1",
    { size: 30, updatable: true, text: false },
    scene
  );
  dustPlane.position = new BABYLON.Vector3(12.5, 7, -26);
  dustPlane.rotation.z = 1.2;
  dustPlane.visibility = 0;
  dustPlane.diffuseColor = new BABYLON.Color3(1, 1, 1);
  dustPlane.useRadianceOverAlpha = false;
  dustPlane.useSpecularOverAlpha = false;

  //pöly katosta - warehouse
  var dustPlane2 = BABYLON.MeshBuilder.CreatePlane(
    "taso2",
    { size: 50, updatable: true, text: false },
    scene
  );
  dustPlane2.position = new BABYLON.Vector3(55, 27, -122);
  dustPlane2.rotation.x = 4.71;
  dustPlane2.visibility = 0;
  dustPlane2.diffuseColor = new BABYLON.Color3(1, 1, 1);
  dustPlane2.useRadianceOverAlpha = false;
  dustPlane2.useSpecularOverAlpha = false;

  //pöly katosta - bunker
  var dustPlane3 = BABYLON.MeshBuilder.CreatePlane(
    "taso3",
    { size: 10, updatable: true, text: false },
    scene
  );
  dustPlane3.position = new BABYLON.Vector3(210, 55, -140);
  dustPlane3.rotation.x = 4.71;
  dustPlane3.visibility = 0;
  dustPlane3.diffuseColor = new BABYLON.Color3(1, 1, 1);
  dustPlane3.useRadianceOverAlpha = false;
  dustPlane3.useSpecularOverAlpha = false;
  //#endregion

  //#region Tehtävät/puzzles ja muut aktivoitavat objektit

  //#region  Flat/Huone1 aktivoitavat objektit

  // Tehtävät/puzzles
  // Flat Puzzle1 - Tietokone 1, jossa Twitter-tehtävä
  var flatPuzzle1 = BABYLON.MeshBuilder.CreateBox(
    "fPuzzle1",
    { height: 4, width: 6.7, depth: 0.1, updatable: true, text: true },
    scene
  );
  flatPuzzle1.position = new BABYLON.Vector3(22, 12, -45);
  flatPuzzle1.visibility = 0;
  flatPuzzle1.rotation.y = 3.8;

  // Flat Puzzle2 - Tietokone 2, jossa lopun tehtävä
  var flatPuzzle2 = BABYLON.MeshBuilder.CreateBox(
    "flatComputer2",
    { height: 3.5, width: 6.7, depth: 0.1, updatable: false, text: true },
    scene
  );
  flatPuzzle2.position = new BABYLON.Vector3(76.3, 11.2, -40.3);
  flatPuzzle2.visibility = 0;
  flatPuzzle2.rotation.y = 2.1;

  // Flat Puzzle3 - Juliste, löytyy salasana jolla pääsee Tietokone 1
  var flatPuzzle3 = BABYLON.MeshBuilder.CreateBox(
    "fPuzzle3",
    { height: 13, width: 9, depth: 0.5, updatable: false, text: true },
    scene
  );
  flatPuzzle3.position = new BABYLON.Vector3(70, 17, -0.2);
  flatPuzzle3.visibility = 0;

  // Flat LockConsole - lukkokonsoli, jolla aukeaa ovi huoneen 1. ja 2. välillä
  var flatLockConsole = BABYLON.MeshBuilder.CreateBox(
    "fLockConsole",
    { height: 3.5, width: 2.5, depth: 0.1, updatable: false, text: true },
    scene
  );
  flatLockConsole.position = new BABYLON.Vector3(54, 5.5, -92);
  flatLockConsole.visibility = 0;

  // Muut huoneen 1. tärkeät objektit
  // Flat - puuoven aktivaattori
  var flatDoorKnob = BABYLON.MeshBuilder.CreateBox(
    "fDoorKnob",
    { height: 20, width: 10, depth: 0.3, updatable: false, text: true },
    scene
  );
  flatDoorKnob.position = new BABYLON.Vector3(63.5, 10, -50);
  flatDoorKnob.visibility = 0;

  // Flat - safari-juliste, 2D kuva, joka antaa vinkki lopun tehtävään
  var flatPosterSafari = BABYLON.MeshBuilder.CreateBox(
    "fPostSafari",
    { height: 12, width: 8.5, depth: 1, updatable: false, text: true },
    scene
  );
  flatPosterSafari.position = new BABYLON.Vector3(41.7, 15.2, -49.7);
  flatPosterSafari.visibility = 0;

  // Huoneen 1. extra objektit

  // Flat - tölkki
  var flatExtra9 = BABYLON.MeshBuilder.CreateBox(
    "fExtra9",
    { height: 2.5, width: 0.75, depth: 0.75, updatable: false, text: true },
    scene
  );
  flatExtra9.position = new BABYLON.Vector3(21, 9.6, -42);
  flatExtra9.visibility = 0;

  // Flat - pallo
  var flatExtra10 = BABYLON.MeshBuilder.CreateBox(
    "fExtra10",
    { height: 2.6, width: 2.6, depth: 2.6, updatable: false, text: true },
    scene
  );
  flatExtra10.position = new BABYLON.Vector3(47.85, 1.3, -47.9);
  flatExtra10.visibility = 0;

  // Flat - lapio
  var flatExtra11 = BABYLON.MeshBuilder.CreateBox(
    "fExtra11",
    { height: 16, width: 2.6, depth: 2.6, updatable: false, text: true },
    scene
  );
  flatExtra11.position = new BABYLON.Vector3(73.5, 1, -89.3);
  flatExtra11.visibility = 0;
  flatExtra11.rotation.x = -0.25;

  // Flat - puhelin
  var flatExtra12 = BABYLON.MeshBuilder.CreateBox(
    "flatPuhelin",
    { height: 2, width: 2.5, depth: 2.5, updatable: false, text: true },
    scene
  );
  flatExtra12.position = new BABYLON.Vector3(48, 4, -17);
  flatExtra12.visibility = 0;

  //#endregion

  //#region Warehouse/Huone2 aktivoitavat objektit

  // Tehtävät/puzzles
  // Warehouse Puzzle1 - tietokone, lopun tehtävään
  var warehousePuzzle1 = BABYLON.MeshBuilder.CreateBox(
    "warehouseComputer",
    { height: 4, width: 6, depth: 0.1, updatable: false, text: true },
    scene
  );
  warehousePuzzle1.position = new BABYLON.Vector3(38, 4.5, -219);
  warehousePuzzle1.visibility = 0;
  warehousePuzzle1.rotation.y = 0.9;

  // Warehouse Puzzle2 - lehti, jossa aktivoituu 2D kuva
  var warehousePuzzle2 = BABYLON.MeshBuilder.CreateBox(
    "whPuzzle2",
    { height: 1, width: 2.7, depth: 2.3, updatable: false, text: true },
    scene
  );
  warehousePuzzle2.position = new BABYLON.Vector3(74.5, 0.7, -135.5);
  warehousePuzzle2.visibility = 0;
  warehousePuzzle2.rotation.y = -0.3;
  /* //näitä objekteja ei ole vielä
// Warehouse Puzzle3 - kamera, josta kuvia mitä selata
var warehousePuzzle3 = BABYLON.MeshBuilder.CreateBox("whPuzzle3",{height: 1, width: 2.7, depth: 2.3, updatable: false, text: true },scene);
    warehousePuzzle3.position = new BABYLON.Vector3(74.5, 0.7, -135.5);
    warehousePuzzle3.visibility = 1;
    warehousePuzzle3.rotation.y = -0.3;
*/
  // Warehouse Puzzle4 - kellolukko, johon pitää aktivoida oikea aika
  var warehousePuzzle4 = BABYLON.MeshBuilder.CreateBox(
    "whPuzzle4",
    { height: 8, width: 1.8, depth: 5.35, updatable: false, text: true },
    scene
  );
  warehousePuzzle4.position = new BABYLON.Vector3(122, 5.3, -196);
  warehousePuzzle4.visibility = 0;

  // Huoneen 2. extra objektit

  // Warehouse - jakoavain
  var warehouseExtra1 = BABYLON.MeshBuilder.CreateBox(
    "whExtra1",
    { height: 0.2, width: 0.6, depth: 2.6, updatable: false, text: true },
    scene
  );
  warehouseExtra1.position = new BABYLON.Vector3(72.8, 0.36, -133.2);
  warehouseExtra1.visibility = 0;
  warehouseExtra1.rotation.y = -1.1;

  // Warehouse - kanisteri v
  var warehouseExtra5 = BABYLON.MeshBuilder.CreateBox(
    "whExtra5",
    { height: 9, width: 6, depth: 2.5, updatable: false, text: true },
    scene
  );
  warehouseExtra5.position = new BABYLON.Vector3(84.89, -5, -206);
  warehouseExtra5.rotation.y = 0.33;
  warehouseExtra5.visibility = 0;

  // Warehouse - puhelin
  var warehouseExtra16 = BABYLON.MeshBuilder.CreateBox(
    "whExtra16",
    { height: 2.3, width: 3, depth: 3, updatable: false, text: true },
    scene
  );
  warehouseExtra16.position = new BABYLON.Vector3(41, 3, -106);
  warehouseExtra16.visibility = 0;
  //#endregion

  //#region Bunker/Huone3 aktivoitavat objektit

  // Tehtävät/puzzles
  // Bunker Puzzle1 - sähkötaulu, tietokoneet Bunkerissa, varastossa, huoneistossa käynnistyvät ja niissä on osa lopun tehtävistä
  var bunkerPuzzle1 = BABYLON.MeshBuilder.CreateBox(
    "bPuzzle1",
    { height: 6.5, width: 4.5, depth: 5, updatable: false, text: true },
    scene
  );
  bunkerPuzzle1.position = new BABYLON.Vector3(124, -11.8, -135);
  bunkerPuzzle1.visibility = 0;

  // Bunker Puzzle2 - tietokone, lopun tehtävään
  var bunkerPuzzle2 = BABYLON.MeshBuilder.CreateBox(
    "bunkerComputer",
    { height: 4, width: 7, depth: 0.3, updatable: false, text: true },
    scene
  );
  bunkerPuzzle2.position = new BABYLON.Vector3(191.3, -22, -141);
  bunkerPuzzle2.visibility = 0;
  bunkerPuzzle2.rotation.y = 0.84;

  // Huoneen 3. extra objektit

  // Bunker - kirjat
  var bunkerExtra3 = BABYLON.MeshBuilder.CreateBox(
    "bExtra3",
    { height: 3.2, width: 3.2, depth: 3.2, updatable: false, text: true },
    scene
  );
  bunkerExtra3.position = new BABYLON.Vector3(188.66, -24.73, -135.67);
  bunkerExtra3.visibility = 0;
  bunkerExtra3.rotation.y = 0.5;

  var bunkerSprayCan = bunkerBox1.clone("bunker_spray");
  bunkerSprayCan.visibility = 0;
  bunkerSprayCan.position = new BABYLON.Vector3(134.67, -26.08, -145.28);
  bunkerSprayCan.scaling.x = 0.12;
  bunkerSprayCan.scaling.y = 1.35;
  bunkerSprayCan.scaling.z = 0.34;

  var bunkerTelephone = bunkerBox1.clone("bunker_tp");
  bunkerTelephone.visibility = 0;
  bunkerTelephone.position = new BABYLON.Vector3(
    133.11349487304688,
    -25.2797908782959,
    -178.281005859375
  );
  bunkerTelephone.scaling.x = 0.15;
  bunkerTelephone.scaling.z = 0.43;
  bunkerTelephone.scaling.y = 0.34;

  //#endregion

  //#endregion

  const particleSystemStuff = () => {
    //#region //Particle-pöly ikkunasta

    var particleSystem = new BABYLON.GPUParticleSystem("particles", 500, scene);
    particleSystem.particleTexture = new BABYLON.Texture(
      window.pakopeliPublicAssetUrl + "img/dust_particle.png",
      scene
    );
    particleSystem.glow = new BABYLON.GlowLayer("particles", scene);

    // Where the particles come from
    particleSystem.emitter = dustPlane; // the starting object, the emitter
    particleSystem.minEmitBox = new BABYLON.Vector3(-10, 6, -10); // Starting all from
    particleSystem.maxEmitBox = new BABYLON.Vector3(3, -2, 3); // To...

    // Colors of all particles
    particleSystem.color1 = new BABYLON.Color4(0.4, 0.4, 0.2, 0.7);
    particleSystem.color2 = new BABYLON.Color4(0.2, 0.2, 0.1, 0.7);
    particleSystem.colorDead = new BABYLON.Color4(0, 0, 0.2, 0.0);

    // Size of each particle (random between...
    particleSystem.minSize = 0.01;
    particleSystem.maxSize = 0.07;

    // Life time of each particle (random between...
    particleSystem.minLifeTime = 0.3;
    particleSystem.maxLifeTime = 1.5;

    // Emission rate
    particleSystem.emitRate = 100;

    // Blend mode : BLENDMODE_ONEONE, or BLENDMODE_STANDARD
    particleSystem.blendMode = BABYLON.GPUParticleSystem.BLENDMODE_ONEONE;

    // Set the gravity of all particles
    particleSystem.gravity = new BABYLON.Vector3(0, -5, 0);

    // Direction of each particle after it has been emitted
    particleSystem.direction1 = new BABYLON.Vector3(7, 8, 3);
    particleSystem.direction2 = new BABYLON.Vector3(-7, -8, -3);

    // Angular speed, in radians
    particleSystem.minAngularSpeed = 0;
    particleSystem.maxAngularSpeed = Math.PI;

    // Nopeus
    particleSystem.minEmitPower = 0.1;
    particleSystem.maxEmitPower = 0.5;
    particleSystem.updateSpeed = 0.002;

    // Particle systemin käynnistys
    particleSystem.start();
    //#endregion

    //#region //Particle-pöly warehousen katosta
    var particleSystem2 = new BABYLON.GPUParticleSystem(
      "particles",
      600,
      scene
    );
    particleSystem2.particleTexture = new BABYLON.Texture(
      window.pakopeliPublicAssetUrl + "img/dust_particle.png",
      scene
    );
    particleSystem2.glow = new BABYLON.GlowLayer("particles", scene);

    // Where the particles come from
    particleSystem2.emitter = dustPlane2; // the starting object, the emitter
    particleSystem2.minEmitBox = new BABYLON.Vector3(-26, -30, -12); // Starting all from
    particleSystem2.maxEmitBox = new BABYLON.Vector3(28, 105, -2); // To...

    // Colors of all particles
    particleSystem2.color1 = new BABYLON.Color4(0.3, 0.3, 0.3, 0.6);
    particleSystem2.color2 = new BABYLON.Color4(0.2, 0.2, 0.2, 0.5);
    particleSystem2.colorDead = new BABYLON.Color4(0.1, 0.1, 0.1, 0.0);

    // Size of each particle (random between...
    particleSystem2.minSize = 0.05;
    particleSystem2.maxSize = 0.08;

    // Life time of each particle (random between...
    particleSystem2.minLifeTime = 0.5;
    particleSystem2.maxLifeTime = 1.8;

    // Emission rate
    particleSystem2.emitRate = 100;

    // Blend mode : BLENDMODE_ONEONE, or BLENDMODE_STANDARD
    particleSystem2.blendMode = BABYLON.GPUParticleSystem.BLENDMODE_ONEONE;

    // Set the gravity of all particles
    particleSystem2.gravity = new BABYLON.Vector3(0, -6, 0);

    // Direction of each particle after it has been emitted
    particleSystem2.direction1 = new BABYLON.Vector3(-0.2, -4, 0.2);
    particleSystem2.direction2 = new BABYLON.Vector3(0.2, -8, -0.2);

    // Angular speed, in radians
    particleSystem2.minAngularSpeed = 0;
    particleSystem2.maxAngularSpeed = 0.15; //Math.PI

    // Nopeus
    particleSystem2.minEmitPower = 0.05;
    particleSystem2.maxEmitPower = 0.08;
    particleSystem2.updateSpeed = 0.002;

    // Particle systemin käynnistys
    particleSystem2.start();
    //#endregion

    //#region //Particle-pöly bunkerin katossa
    var particleSystem3 = new BABYLON.GPUParticleSystem(
      "particles",
      200,
      scene
    );
    particleSystem3.particleTexture = new BABYLON.Texture(
      window.pakopeliPublicAssetUrl + "img/dust_particle.png",
      scene
    );
    particleSystem3.glow = new BABYLON.GlowLayer("particles", scene);

    // Where the particles come from
    particleSystem3.emitter = dustPlane3; // the starting object, the emitter
    particleSystem3.minEmitBox = new BABYLON.Vector3(-50, -25, -3); // Starting all from
    particleSystem3.maxEmitBox = new BABYLON.Vector3(15, 20, 3); // To...

    // Colors of all particles
    particleSystem3.color1 = new BABYLON.Color4(0.4, 0.4, 0.4, 0.7);
    particleSystem3.color2 = new BABYLON.Color4(0.2, 0.2, 0.2, 0.7);
    particleSystem3.colorDead = new BABYLON.Color4(0.2, 0.2, 0, 0.1);

    // Size of each particle (random between...
    particleSystem3.minSize = 0.08;
    particleSystem3.maxSize = 0.2;

    // Life time of each particle (random between...
    particleSystem3.minLifeTime = 1.3;
    particleSystem3.maxLifeTime = 1.8;

    // Emission rate
    particleSystem3.emitRate = 50;

    // Blend mode : BLENDMODE_ONEONE, or BLENDMODE_STANDARD
    particleSystem3.blendMode = BABYLON.GPUParticleSystem.BLENDMODE_ONEONE;

    // Set the gravity of all particles
    particleSystem3.gravity = new BABYLON.Vector3(0, -5.5, 0);

    // Direction of each particle after it has been emitted
    particleSystem3.direction1 = new BABYLON.Vector3(7, 8, 3);
    particleSystem3.direction2 = new BABYLON.Vector3(-7, -8, -3);

    // Angular speed, in radians
    particleSystem3.minAngularSpeed = 0;
    particleSystem3.maxAngularSpeed = Math.PI;

    // Nopeus
    particleSystem3.minEmitPower = 0.1;
    particleSystem3.maxEmitPower = 0.5;
    particleSystem3.updateSpeed = 0.002;

    // Particle systemin käynnistys
    particleSystem3.start();
    //#endregion
  };

  //particleSystemStuff();
  //#endregion

  const cameraHelpers = {
    camera: camera,
    attachControl: () => camera.attachControl(canvas, true),
    detachControl: () => camera.detachControl(document.querySelector("canvas")),
  };


  gameSounds = createSounds(scene);

  window.scene = scene;
  window.userChoiceTracker = userChoiceTracker;


  document.querySelector(".info-ikoni").addEventListener("click", InfoScreen);

  return { scene, cameraHelpers };
};

function startGame(parameters) {
  const logo = parameters?.logo


  document.getElementById("click-with-mouse").innerText = textContents.clickScreen["1"]
  let engine;
  const canvas = document.getElementById("renderCanvas");
  pointerLockEvents.init(canvas);

  engine = new BABYLON.Engine(canvas, true, {
    preserveDrawingBuffer: true,
    doNotHandleContextLost: true,
    antialias: false,
    stencil: true,
  });
  if (!shortcutDetected()) {
    StartingScreen(engine, logo);
  }
  // var available = [
  //   "-astc.ktx",
  //   "-dxt.ktx",
  //   "-pvrtc.ktx",
  //   "-etc2.ktx",
  //   "-etc1.ktx",
  // ];

  //var formatUsed = engine.setTextureFormatToUse(available);
  const { scene, cameraHelpers } = createScene(engine, canvas);
  if (window.location.hash === "#debug") {
    scene.debugLayer.show({ overlay: true });
  }

  customCameraHelpers.init(cameraHelpers);
  engine.runRenderLoop(function () {
    if (scene) {
      scene.render();
    }
  });
}

export const init = (parameters) => {
BABYLON.DefaultLoadingScreen.prototype.displayLoadingUI = displayLoadingUI;
BABYLON.DefaultLoadingScreen.prototype.hideLoadingUI = hideLoadingUI;
const isDuoApp = parameters?.svtDuo
window.doorTriggers = () => doorTriggers;

if (mobileOrNot()) {
    document.body.classList.add("mobile");

    if (!isDuoApp && window.innerWidth < window.innerHeight) {
      // MOBILE && PORTRAIT

      window.onresize = function () {
        if (window.innerWidth > window.innerHeight) {
          setTimeout(() => startGame(parameters), 1000);
          window.onresize = null;
        }
      };
    } else {
      // MOBILE && (LANDSCAPE || DUOAPP)
      startGame(parameters);
    }
  } else {
    // DESKTOP
    startGame(parameters);
  }
};
